export * from '@magnetarjs/core';
export * from '@magnetarjs/utils';
import * as pluginFirestore from '@magnetarjs/plugin-firestore';
export { pluginFirestore as PluginFirestore };
import * as pluginSimpleStore from '@magnetarjs/plugin-simple-store';
export { pluginSimpleStore as PluginSimpleStore };
import * as pluginVue2 from '@magnetarjs/plugin-vue2';
export { pluginVue2 as PluginVue2 };
import * as pluginVue3 from '@magnetarjs/plugin-vue3';
export { pluginVue3 as PluginVue3 };
